import React from 'react';
import BookingFlowStep from '../BookingFlowStep';

type FlowStepsProps = {
  currentStep: number;
  steps: {
    label: string;
    stepNumber: number;
  }[];
  innerClass?: string;
  getHrefForStep: (n: number) => string | null;
}

const FlowSteps: React.FC<FlowStepsProps> = ({
  currentStep,
  steps,
  innerClass = '',
  getHrefForStep,
}) => {
  return (
    <div className="bg-paleOrange flex justify-center py-6">
      <div className={`flex w-full items-baseline justify-between ${innerClass}`}>
        {steps.map((step, index) => {
          const isCompleted = step.stepNumber <= currentStep;

          return (
            <React.Fragment key={step.label}>
              <BookingFlowStep
                stepNumber={step.stepNumber}
                label={step.label}
                isCompleted={isCompleted}
                href={isCompleted ? getHrefForStep(step.stepNumber) : null}
              />
              {index < steps.length - 1 && (
                <div className="border-b-[1px] border-solid border-b-primary flex-1 h-[1px]" />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default FlowSteps;

